import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { DeviceFrame } from './DeviceFrame';
const steps = [{
  n: '1',
  title: 'Find what applies',
  caption: 'The reader identifies where the book connects to their situation.',
  src: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/6df5644c-2472-4ba3-85fd-cd40288deae1/02_diagnostic_starting_point.png",
  url: 'simplifytoamplify.com/starting-point',
  aspect: '4 / 3',
  eager: true
}, {
  n: '2',
  title: 'See what it means',
  caption: 'The ideas become specific to what they are experiencing.',
  src: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/6df5644c-2472-4ba3-85fd-cd40288deae1/03_personalized_readout.png",
  url: 'simplifytoamplify.com/your-growth-leak',
  aspect: '4 / 3',
  eager: false
}, {
  n: '3',
  title: 'Choose a useful next move',
  caption: 'Insight becomes a concrete action rather than another unfinished idea.',
  src: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/6df5644c-2472-4ba3-85fd-cd40288deae1/04_next_move_builder.png",
  url: 'simplifytoamplify.com/my-plan',
  aspect: '4 / 3',
  eager: false
}];
export function PrototypeProof() {
  return <SectionBand tone="paperDark" width="wide" data-id="element-802" data-mp="306w9hwqqw20d">
      <div className="max-w-3xl" data-id="element-803" data-mp="1nz3tu9sbor1">
        <Reveal data-id="element-804" data-mp="1o8jop148fj0">
          <Eyebrow data-id="element-805" data-mp="1mnpx1mml0m7">Real proof</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-tight text-navy md:text-5xl" data-id="element-806" data-mp="1pryscb1ckj7">
            What this looks like{' '}
            <span className="italic text-seaglass" data-id="element-807" data-mp="3o309e96keryk">in practice.</span>
          </h2>
          <span className="mt-5 inline-block rounded-full border border-gray-300/70 bg-paper px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-navy" data-id="element-808" data-mp="3j4gq6gjcvu9w">
            Simplify to Amplify — working Reader-to-Revenue prototype
          </span>
        </Reveal>
      </div>

      <div className="mt-14 flex flex-col gap-12 md:gap-16" data-id="element-809" data-mp="flx3runczin0">
        {steps.map((step, i) => <Reveal key={step.n} delay={0.05} data-id="element-810" data-mp="29wdmbi1fqsdx" data-mpi={i}>
            <div className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-811" data-mp="2dxp451e2i9bk">
              <div className={i % 2 === 1 ? 'md:order-2' : ''} data-id="element-812" data-mp="205sgpancgnli">
                <div className="flex items-center gap-4" data-id="element-813" data-mp="205iqpn2augft">
                  <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-seaglass font-serif text-lg text-white" data-id="element-814" data-mp="2542e7rwjk0aa">
                    {step.n}
                  </span>
                  <h3 className="font-serif text-2xl text-navy md:text-3xl" data-id="element-815" data-mp="1v6xyoax7b32g">
                    {step.title}
                  </h3>
                </div>
                <p className="mt-4 max-w-md text-lg leading-relaxed text-text-muted" data-id="element-816" data-mp="1h99fd7is83zi">
                  {step.caption}
                </p>
              </div>
              <div className={i % 2 === 1 ? 'md:order-1' : ''} data-id="element-817" data-mp="3bm91ljho3wfr">
                <div className="rounded-3xl bg-navy p-4 md:p-6" data-id="element-818" data-mp="3gjr00fy26t9i">
                  <DeviceFrame variant="browser" src={step.src} alt={`Simplify to Amplify prototype — ${step.title}`} url={step.url} aspect={step.aspect} loading={step.eager ? 'eager' : 'lazy'} data-id="element-819" data-mp="3ghy3hth5tpf8" />
                </div>
              </div>
            </div>
          </Reveal>)}
      </div>
    </SectionBand>;
}